import { useState, ReactElement } from 'react';
import { Typography } from '../Typography/Typography';
import Avatar from '../Avatar/Avatar';
import UserDropdown from '../UserDropdown/UserDropdown';
import { useClickOutside } from '../../hooks/useClickOutside';
import { Burger } from '../../assets/icons/Burger';
import getInitials from './utilities/getInitials';
import styles from './Header.module.scss';
import React from 'react';

export interface IHeaderProps {
  name: string;
  userRole: string;
  switchAppName: string;
  switchLink: string;
  isAdminButtonEnabled: boolean;
  onDrawerToggle: () => void;
  onLogout: () => void;
}

const Header = ({
  name,
  userRole,
  switchAppName,
  switchLink,
  isAdminButtonEnabled,
  onDrawerToggle,
  onLogout,
}: IHeaderProps): ReactElement => {
  const [showUserDropdown, setShowUserDropdown] = useState<boolean>(false);
  const initials = getInitials(name);

  const handleOpenUserMenu = () => setShowUserDropdown((prevState: boolean) => !prevState);

  const domNode = useClickOutside<HTMLDivElement>(() => setShowUserDropdown(false));

  return (
    <>
      <header className={styles['header']}>
        <button onClick={onDrawerToggle} aria-label="sidebar-menu-button" className={styles['hamburger']}>
          <Burger />
        </button>
        <div className={styles['user-container']} data-cy="user-container" ref={domNode}>
          <div className={styles['greeting-container']}>
            <Typography size="S" weight="regular">
              Welcome,
            </Typography>
            <Typography size="S" weight="semi-bold" transform="capitalize">
              {name}
            </Typography>
          </div>
          <Avatar initials={initials} onClick={handleOpenUserMenu} active={showUserDropdown} />
        </div>
      </header>
      <UserDropdown
        open={showUserDropdown}
        name={name}
        initials={initials}
        role={userRole}
        switchAppName={switchAppName}
        switchLink={switchLink}
        isAdminButtonEnabled={isAdminButtonEnabled}
        onLogout={onLogout}
      />
      <div className={styles['divider']} />
    </>
  );
};

export default Header;
